export default "<!-- <div [@routerAnimation]=\"getRouteAnimation(route)\"> -->\r\n  <router-outlet ></router-outlet>\r\n<!-- </div> -->"